import React from "react";
import { useLang, IMAGES } from "../i18n";
import { Reveal } from "./Motion";
import { MapPin, Mail } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const nav = t.nav;
  return (
    <footer id="contact" data-testid="footer" className="relative bg-[var(--bg-secondary)] border-t border-[var(--border)] pt-24 pb-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-24">
          <div className="lg:col-span-5">
            <p className="font-cormorant italic text-3xl md:text-4xl text-[var(--text-primary)] leading-tight max-w-md">
              {f.tagline}
            </p>
            <div className="mt-8 space-y-3">
              <a href={`mailto:${f.email}`} data-testid="footer-email" className="flex items-center gap-3 font-outfit text-[var(--text-secondary)] hover:text-[var(--gold)] transition-colors">
                <Mail className="w-4 h-4" /> {f.email}
              </a>
              <div className="flex items-start gap-3 font-outfit text-[var(--text-secondary)]">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span data-testid="footer-legal-address"><span className="text-[var(--text-primary)]">{f.legalLabel}:</span> {f.legalAddress}</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <div className="overline text-[10px] text-[var(--text-secondary)] mb-5">{f.col1}</div>
            <ul className="space-y-3">
              {[["#about", nav.about], ["#patent", nav.patent], ["#services", nav.services], ["#vision", nav.vision], ["#sectors", nav.sectors]].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="font-outfit text-[var(--text-primary)] hover:text-[var(--gold)] transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline text-[10px] text-[var(--text-secondary)] mb-5">{f.col3}</div>
            <p className="font-outfit text-[var(--text-primary)]">{f.legalAddress}</p>
            <p data-testid="footer-vat" className="font-outfit text-[var(--text-secondary)] text-sm mt-2">{f.vat}</p>
            <p className="font-outfit text-[var(--text-secondary)] text-sm mt-1">Italia · Brasile · 150+</p>
          </div>
        </div>

        {/* massive lockup */}
        <Reveal>
          <div className="border-t border-[var(--border)] pt-14 flex flex-col items-center gap-6">
            <img
              src={IMAGES.logo}
              alt="Amazonico3000"
              className="h-40 md:h-56 w-auto"
            />
            <p className="font-cormorant italic text-2xl md:text-3xl text-[var(--text-secondary)] text-center max-w-xl">
              {f.tagline}
            </p>
          </div>
        </Reveal>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-10 pt-6 border-t border-[var(--border)]">
          <span className="overline text-[10px] text-[var(--text-secondary)]">
            © {new Date().getFullYear()} Amazonico3000 — {f.rights}
          </span>
          <span className="overline text-[10px] text-[var(--gold)]">
            {f.startup}
          </span>
        </div>
      </div>
    </footer>
  );
};

